export function createFile(name: string) {
    const properties = { type: 'text/plain' };
    const fileName = `migration_${name}`;
    const file = new File([localStorage.getItem(name) ?? ''], fileName, properties);
    return URL.createObjectURL(file);
}
